import * as React from 'react';

function SvgComponent(props) {
    return (
        <svg
            width={30}
            height={30}
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g clipPath="url(#clip0_1839_1749)">
                <mask
                    id="a"
                    style={{
                        maskType: 'luminance',
                    }}
                    maskUnits="userSpaceOnUse"
                    x={0}
                    y={0}
                    width={30}
                    height={30}
                >
                    <path d="M30 0H0v29.976h30V0z" fill="#fff" />
                </mask>
                <g mask="url(#a)">
                    <path
                        d="M27.572 0H22.11a2.416 2.416 0 00-2.407 2.406v7.06h-7.908a2.336 2.336 0 00-2.327 2.347v7.908H2.35a2.34 2.34 0 00-2.347 2.347v5.522c0 1.301 1.045 2.347 2.347 2.386h25.243a2.416 2.416 0 002.406-2.406V2.406C29.978 1.085 28.893 0 27.572 0z"
                        fill="url(#paint0_linear_1839_1749)"
                    />
                    <path
                        d="M27.572 0H22.11a2.416 2.416 0 00-2.407 2.406v7.06h-7.908a2.336 2.336 0 00-2.327 2.347v7.908H2.35a2.34 2.34 0 00-2.347 2.347v5.522c0 1.301 1.045 2.347 2.347 2.386h25.243a2.416 2.416 0 002.406-2.406V2.406C29.978 1.085 28.893 0 27.572 0z"
                        fill="url(#paint1_linear_1839_1749)"
                    />
                    <path
                        d="M27.572 0H22.15a2.416 2.416 0 00-2.406 2.406v27.57h7.83a2.416 2.416 0 002.405-2.406V2.406A2.416 2.416 0 0027.572 0z"
                        fill="#F57C00"
                    />
                    <path
                        d="M9.468 11.833v7.888h-7.1a2.373 2.373 0 00-2.366 2.366v5.522a2.374 2.374 0 002.367 2.367h17.354V9.466h-7.888a2.373 2.373 0 00-2.367 2.367z"
                        fill="#FFC107"
                    />
                    <path
                        d="M19.723 9.466v20.51h7.83a2.416 2.416 0 002.405-2.406v-7.849L19.723 9.466z"
                        fill="url(#paint2_linear_1839_1749)"
                    />
                    <path
                        opacity={0.2}
                        d="M11.835 9.663h7.888v-.197h-7.888a2.373 2.373 0 00-2.367 2.367v.197a2.373 2.373 0 012.367-2.367zM2.369 19.918h7.1v-.197h-7.1a2.373 2.373 0 00-2.367 2.367v.197a2.373 2.373 0 012.367-2.367zM27.572 0H22.15a2.416 2.416 0 00-2.406 2.406v.197A2.416 2.416 0 0122.149.197h5.423a2.416 2.416 0 012.406 2.406v-.197A2.416 2.416 0 0027.572 0z"
                        fill="#fff"
                    />
                    <path
                        opacity={0.2}
                        d="M27.572 29.779H2.37a2.374 2.374 0 01-2.367-2.367v.198a2.374 2.374 0 002.367 2.366h25.183a2.416 2.416 0 002.407-2.406v-.197c.02 1.321-1.066 2.406-2.387 2.406z"
                        fill="#BF360C"
                    />
                    <path
                        d="M27.572 0H22.15a2.416 2.416 0 00-2.406 2.406v7.06h-7.888a2.373 2.373 0 00-2.367 2.367v7.888h-7.12a2.373 2.373 0 00-2.366 2.367v5.521a2.373 2.373 0 002.367 2.367h25.203a2.416 2.416 0 002.406-2.406V2.406A2.416 2.416 0 0027.572 0z"
                        fill="url(#paint3_linear_1839_1749)"
                    />
                </g>
            </g>
            <defs>
                <linearGradient
                    id="paint0_linear_1839_1749"
                    x1={0.00219727}
                    y1={14.988}
                    x2={29.9979}
                    y2={14.988}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#fff" stopOpacity={0.1} />
                    <stop offset={1} stopColor="#fff" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_1839_1749"
                    x1={0.00219727}
                    y1={14.988}
                    x2={29.9979}
                    y2={14.988}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#fff" stopOpacity={0.1} />
                    <stop offset={1} stopColor="#fff" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_1839_1749"
                    x1={14.645}
                    y1={14.6428}
                    x2={29.2602}
                    y2={29.2581}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#BF360C" stopOpacity={0.2} />
                    <stop offset={1} stopColor="#BF360C" stopOpacity={0.02} />
                </linearGradient>
                <linearGradient
                    id="paint3_linear_1839_1749"
                    x1={10.0538}
                    y1={10.0638}
                    x2={29.4447}
                    y2={29.4548}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#fff" stopOpacity={0.1} />
                    <stop offset={1} stopColor="#fff" stopOpacity={0} />
                </linearGradient>
                <clipPath id="clip0_1839_1749">
                    <path fill="#fff" d="M0 0H30V30H0z" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default SvgComponent;
